import {
  TEV_SCHEMA_VERSION,
  TEV_APP_VERSION,
  TEV_APP_NAME,
  TEV_FILE_TYPE,
} from "../constants";

/**
 * @typedef {import('../types/token').Token} Token
 * @typedef {import('../types/chunk').Chunk} Chunk
 * @typedef {import('../types/pca').PCA} PCA
 * @typedef {import('../types/embedding').Embedding} Embedding
 * @typedef {import('../types/embeddingModelInfo').EmbeddingModelInfo} EmbeddingModelInfo
 * @typedef {import('../types/visualizationParams').VisualizationParams} VisualizationParams
 */

/**
 * Builds a save object for persisting a text embedding visualization.
 * The object conforms to the TEV save file schema (see schema.json).
 *
 * @param {Object} obj
 * @param {string} obj.inputText - The original input text.
 * @param {Token[]} obj.tokens - Array of tokens from the input text.
 * @param {Chunk[]} obj.chunks - Array of chunks with metadata.
 * @param {PCA} obj.pcaResult - The PCA result object (with pcaMatrix, pcaMeanVector, etc.)
 * @param {EmbeddingModelInfo} obj.embeddingModelInfo - Object describing the embedding model.
 * @param {Object} obj.chunking - Object describing the chunking parameters.
 * @param {VisualizationParams} [obj.visualizationParams] - Optional object with visualization settings.
 * @returns {Object} The save object, with the required properties and optional visualizationParams.
 */
export function buildVisualizationSaveObject({
  inputText,
  tokens,
  chunks,
  pcaResult,
  embeddingModelInfo,
  chunking,
  visualizationParams,
}) {
  return {
    type: TEV_FILE_TYPE,
    appName: TEV_APP_NAME,
    schemaVersion: TEV_SCHEMA_VERSION,
    appVersion: TEV_APP_VERSION,
    inputText,
    embeddingModelInfo,
    chunking,
    tokens,
    chunks,
    pcaResult,
    ...(visualizationParams ? { visualizationParams } : {}),
    createdAt: new Date().toISOString(),
  };
}
